/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ScimAttributeMappingConfigurationRequest } from './';
import {
    ScimAttributeMappingConfigurationRequestFromJSON,
    ScimAttributeMappingConfigurationRequestFromJSONTyped,
    ScimAttributeMappingConfigurationRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateScimAttributeMappingRequest
 */
export interface UpdateScimAttributeMappingRequest {
    /**
     * 
     * @type {Array<ScimAttributeMappingConfigurationRequest>}
     * @memberof UpdateScimAttributeMappingRequest
     */
    mappings: Array<ScimAttributeMappingConfigurationRequest>;
}

/**
 * Check if a given object implements the UpdateScimAttributeMappingRequest interface.
 */
export function instanceOfUpdateScimAttributeMappingRequest(value: object): value is UpdateScimAttributeMappingRequest {
    if (!('mappings' in value) || value['mappings'] === undefined) return false;
    return true;
}

export function UpdateScimAttributeMappingRequestFromJSON(json: any): UpdateScimAttributeMappingRequest {
    return UpdateScimAttributeMappingRequestFromJSONTyped(json, false);
}

export function UpdateScimAttributeMappingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScimAttributeMappingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mappings': ((json['mappings'] as Array<any>).map(ScimAttributeMappingConfigurationRequestFromJSON)),
    };
}

export function UpdateScimAttributeMappingRequestToJSON(value?: UpdateScimAttributeMappingRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'mappings': ((value['mappings'] as Array<any>).map((v) => ScimAttributeMappingConfigurationRequestToJSON(v))),
    };
}

